import { Box } from '@mui/material';
import { styled } from '@mui/material/styles';

export const KpiGrid = styled(Box)(({ theme }) => ({
  display: 'grid',
  gap: '16px',
  gridTemplateColumns: 'repeat(4, 1fr)',
  marginBottom: '24px',
  [theme.breakpoints.down('lg')]: {
    gridTemplateColumns: 'repeat(2, 1fr)',
  },
  [theme.breakpoints.down('sm')]: {
    gridTemplateColumns: '1fr',
  },
}));

export const PillarGrid = styled(Box)(({ theme }) => ({
  display: 'grid',
  gap: '16px',
  gridTemplateColumns: 'repeat(4, 1fr)',
  [theme.breakpoints.down('lg')]: {
    gridTemplateColumns: 'repeat(2, 1fr)',
  },
  [theme.breakpoints.down('sm')]: {
    gridTemplateColumns: '1fr',
  },
}));

export const ChartsGrid = styled(Box)(({ theme }) => ({
  display: 'grid',
  gap: '16px',
  gridTemplateColumns: '1fr 1fr',
  margin: '24px 0',
  [theme.breakpoints.down('lg')]: {
    gridTemplateColumns: '1fr',
  },
}));

export const SectionSpacer = styled(Box)(() => ({
  marginTop: '24px',
}));
